import React from 'react';
import {FormattedMessage} from 'react-intl';
import Avatar from 'material-ui/Avatar';
import {ListComponent} from '../../List';
import {
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
  TableHeader,
  TableHeaderColumn
} from 'material-ui/Table';

import ListActionItems from '../../List/ListActionItems';
import AddButton from './../../AddButton';
import LoadMore from '../../LoadMore';
import LoggedAppBar from '../../LoggedLayout/LoggedAppBar';
import LoadingSpinner from '../../LoadingSpinner';

class ParticipantsList extends ListComponent {
  static contextTypes = {
    muiTheme: React.PropTypes.object
  };

  confirmRemoveMessage = (
    <FormattedMessage
      id="opponent.remove"
      defaultMessage="Are you sure want to delete opponent?"
    />
  );

  render() {
    let {add, list, items, hasMore, loading} = this.props;
    let {palette: {labelColor}, tableHeaderColumn} = this.context.muiTheme;
    let records = list.map(id => items[id]);
    let fixedColumn = {style: {width: '120px', color: labelColor}};
    let iconBox = {style: {width: '120px', position: 'relative', left: '-12px'}};

    let flexRowStyle = {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      padding: '24px 0'
    };

    let nameStyle={
      paddingLeft: '22px'
    };

    return (
      <div>
        <LoggedAppBar title="Opponents" isStatic />
        <LoadingSpinner show={loading}>
          <LoadMore active={hasMore} loadMore={() => this.loadMore()}>
            <Table selectable={false}>
              <TableHeader adjustForCheckbox={false} displaySelectAll={false} enableSelectAll={false}
                           style={{
                             backgroundColor: tableHeaderColumn.bgColor
                           }}
              >
                <TableRow>
                  <TableHeaderColumn style={{color: labelColor}}>Opponent</TableHeaderColumn>
                  <TableHeaderColumn {...fixedColumn}>Options</TableHeaderColumn>
                </TableRow>
              </TableHeader>

              <TableBody displayRowCheckbox={false}>
                {records.length > 0
                  ? records.map(({id, name, logo}) => (
                  <TableRow key={id}>
                    <TableRowColumn>
                      <div style={flexRowStyle}>
                        <Avatar size={60} src={logo.thumbnail} />
                        <div style={nameStyle}>{name}</div>
                      </div>
                    </TableRowColumn>

                    <TableRowColumn {...iconBox}>
                      <ListActionItems
                        edit={this.props.edit}
                        remove={this.props.delete}
                        record={items[id]}
                        confirmMessageLabel={this.confirmRemoveMessage}
                        displayRemove={false}
                      />
                    </TableRowColumn>
                  </TableRow>
                ))
                  : (<TableRow><TableRowColumn columnNumber={6}>Empty list</TableRowColumn></TableRow>)
                }
              </TableBody>
            </Table>
          </LoadMore>
        </LoadingSpinner>
        <AddButton onClick={add}/>
      </div>
    );
  }
}

export default ParticipantsList;





// WEBPACK FOOTER //
// ./src/components/Participants/ParticipantsList/ParticipantsList.js